"use client"
import { useState, type ReactNode } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

export default function ReactQueryProvider({
    children,
}: {
    children: ReactNode
}) {
    // Create the QueryClient once per app lifecycle on the client
    const [queryClient] = useState(() => new QueryClient())

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    )
}
